import React, { useCallback } from 'react';
import { CardView, rem } from 'design-system';
import Text from 'design-system/Text';
import TextWithLinks from 'design-system/TextWithLinks';
import useColors from 'hooks/useColors';
import { StyleSheet, View } from 'react-native';
import { IconError } from 'design-system/icons/IconError';
import IconCheck from 'design-system/icons/IconCheck';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const CreditFactorPill = ({ positiveFactor }) => {
    const colors = useColors();
    return (<View style={[
            styles.creditFactorPillContainer,
            {
                backgroundColor: positiveFactor
                    ? colors.elements.statusPositiveLight
                    : colors.elements.statusInformationalLight,
            },
        ]}>
      {positiveFactor ? (<IconCheck thick color={colors.elements.statusPositive} width={rem(16)} height={rem(16)}/>) : (<IconError color={colors.elements.statusInformational} width={rem(16)} height={rem(16)}/>)}
      <Text Text-14 color={positiveFactor
            ? colors.text.statusPositive
            : colors.text.statusInformational}>
        {positiveFactor ? 'Doing great' : 'Impacting'}
      </Text>
    </View>);
};
const CreditScoreEnhancedFactorCard = ({ positiveFactor, title, subTitle, pressDisabled = true, highestImpact, smallMargin, }) => {
    const navigation = useMainStackNavigation();
    const onPress = useCallback(() => navigation.navigate('CreditScoreEnhancedCreditFactors'), [navigation]);
    return (<TouchableBounce onPress={onPress} disabled={pressDisabled}>
      <CardView noMarginTop withPadding style={[styles.cardContainer, smallMargin && styles.smallMaergin]}>
        <View>
          {highestImpact ? (<Text Text-12 Primary>
              {'HIGHEST IMPACT'}
            </Text>) : (<CreditFactorPill positiveFactor={positiveFactor}/>)}
        </View>
        <View>
          <Text Text-16>{title}</Text>
          <TextWithLinks TextThin-14 Secondary>
            {subTitle}
          </TextWithLinks>
        </View>
      </CardView>
    </TouchableBounce>);
};
const styles = StyleSheet.create({
    cardContainer: {
        gap: rem(4),
    },
    smallMaergin: {
        marginBottom: rem(8),
    },
    creditFactorPillContainer: {
        alignSelf: 'flex-start',
        paddingHorizontal: rem(12),
        paddingVertical: rem(4),
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(4),
        borderRadius: rem(100),
    },
});
export default CreditScoreEnhancedFactorCard;
